import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * Text that has a leading and trailing horizonal line surrounding it.
 */ export const DividerText = (param)=>{
    let { children = "or" } = param;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mb-6 mt-5 h-auto overflow-hidden text-center text-12 font-semibold text-grey-10",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "relative right-4 ml-[-50%] inline-block h-px w-1/2 bg-grey-4 align-middle"
            }),
            children,
            /*#__PURE__*/ _jsx("div", {
                className: "relative left-4 mr-[-50%] inline-block h-px w-1/2 bg-grey-4 align-middle"
            })
        ]
    });
};
